<template>
  <v-container>
    <v-dialog
      v-if="dialog"
      v-model="dialog"
      max-width="900px"
      scrollable
      persistent
    >
      <v-card>
        <v-card-title> Edit Taxonomy </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12">
                <v-text-field
                  dense
                  outlined
                  label="Search an APD taxonomy here..."
                  v-model="searchTaxon"
                ></v-text-field>
              </v-col>
              <v-col v-if="selectedTaxon.length > 0" cols="12" sm="12">
                <v-banner
                  color="success"
                  dark
                  elevation="2"
                  single-line
                  style="font-size: 1em"
                  >Selected taxon:
                  {{
                    '"' +
                    selectedTaxon[0].taxon_name +
                    '" (' +
                    selectedTaxon[0].id_family.family_name +
                    ")"
                  }}</v-banner
                >
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-layout child-flex>
                  <v-data-table
                    item-key="id_taxon"
                    :items="getTaxonsAll"
                    show-select
                    :search="searchTaxon"
                    :headers="headersTaxons"
                    v-model="selectedTaxon"
                    single-select
                    :footer-props="{
                      'items-per-page-options': [5],
                    }"
                    :items-per-page="5"
                  >
                  </v-data-table>
                </v-layout>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close"> Close </v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogNewTaxon = true" color="error">
            Can't find taxonomy in APD dictionnary
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="save" :disabled="selectedTaxon.length === 0">
            Apply and save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <UnregisteredTaxonsNewTaxon
      :dialog.sync="dialogNewTaxon"
      :editedItem.sync="editedItem"
      :editedIndex.sync="editedIndex"
      :selectedTaxon.sync="selectedTaxon"
      :unregisteredTaxons.sync="unregisteredTaxons"
      @close="close">
      
    </UnregisteredTaxonsNewTaxon>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import UnregisteredTaxonsNewTaxon from './UnregisteredTaxonsNewTaxon.vue';
export default {
  components: { UnregisteredTaxonsNewTaxon },
  name: "UnregisteredTaxonEdit",
  props: {
    dialog: {
      type: Boolean,
    },
    unregisteredTaxons: {
      type: Array,
    },
    selectedTaxon: {
      type: Array,
    },
    editedItem: {},
    editedIndex: {},
  },
  data() {
    return {
      searchTaxon: "",
      dialogNewTaxon:false,
      headersTaxons: [
        {
          text: "APD Taxonomy",
          align: "start",
          filterable: true,
          value: "taxon_name",
        },

        {
          text: "APD family name",
          filterable: true,
          value: "id_family.family_name",
        },
        {
          text: "Plant Habit",
          filterable: false,
          value: "plant_habit",
        },
        {
          text: "Pollen Habit",
          filterable: false,
          value: "id_pollen_habit.pollen_habit_code",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getTaxonsAll"]),
  },
  methods: {
    ...mapActions(["addAuthorTaxon2", "updateAuthorTaxon2"]),
    close() {
      this.$emit("update:dialog", false);
      this.$emit("update:editedItem", Object.assign({}, this.defaultItem));
      this.$emit("update:editedIndex", -1);
      this.$emit("update:selectedTaxon", []);

      this.searchTaxon = "";
    },
    async save() {
      if (this.editedIndex > -1) {
        let newtaxon = {
          id_authortaxon: this.unregisteredTaxons[this.editedIndex]
            .id_authortaxon,
          authortaxon_name: this.unregisteredTaxons[
            this.editedIndex
          ].authortaxon_name
            .toString()
            .trim(),
          id_taxon: this.selectedTaxon[0].id_taxon,
          taxon_name: this.selectedTaxon[0].taxon_name,
          plant_habit: this.selectedTaxon[0].plant_habit,
          id_pollen_habit: this.selectedTaxon[0].id_pollen_habit
            .id_pollen_habit,
          pollen_habit_code: this.selectedTaxon[0].id_pollen_habit
            .pollen_habit_code,
          id_family: this.selectedTaxon[0].id_family.id_family,
          family_name: this.selectedTaxon[0].id_family.family_name,
        };

        if (!newtaxon.id_authortaxon) {
          let resp = await this.addAuthorTaxon2({
            authortaxon_name: newtaxon.authortaxon_name,
            id_taxon: newtaxon.id_taxon,
          });
          newtaxon.id_authortaxon = resp.id_authortaxon;
        } else {
          await this.updateAuthorTaxon2({
            id_authortaxon: newtaxon.id_authortaxon,
            id_taxon: newtaxon.id_taxon,
          });
        }

        this.unregisteredTaxons.splice(this.editedIndex, 1);
      }
      this.close();
    },
  },
};
</script>

<style>
</style>